import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeaderboard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7 8V17M7 8H2.59961C2.03956 8 1.75981 8 1.5459 8.10899C1.35774 8.20487 1.20487 8.35774 1.10899 8.5459C1 8.75981 1 9.04004 1 9.6001V17H7M7 8V2.6001C7 2.04004 7 1.75981 7.10899 1.5459C7.20487 1.35774 7.35774 1.20487 7.5459 1.10899C7.75981 1 8.03956 1 8.59961 1H11.3996C11.9597 1 12.2403 1 12.4542 1.10899C12.6423 1.20487 12.7948 1.35774 12.8906 1.5459C12.9996 1.75981 13 2.04005 13 2.6001V5M7 17H13M13 17L19 17.0001V6.6001C19 6.04005 18.9996 5.75981 18.8906 5.5459C18.7948 5.35774 18.6429 5.20487 18.4548 5.10899C18.2409 5 17.9601 5 17.4 5H13M13 17V5",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLeaderboard;
